import { format } from 'date-fns'
export const localTimezone =
  (typeof Intl === 'object' &&
    Intl.DateTimeFormat().resolvedOptions().timeZone) ||
  ''

export function displayDate(date) {
  return format(date, 'MMMM dd, yyyy')
}

export function displayTime(date) {
  return format(date, `h:mm a`)
}
